// import { Headers, RequestOptions } from '@angular/http';
import { HttpHeaders } from '@angular/common/http';
import * as i0 from "@angular/core";
export class HttpHelperService {
    configOptionsForPost() {
        let headers = new Headers();
        headers.append('Content-Type', 'application/x-www-form-urlencoded');
        let options;
        // = new RequestOptions({ headers: headers });		
        return options;
    }
    configOptionsForPostPayload() {
        let headers = new Headers();
        headers.append('Content-Type', 'application/json');
        let options;
        // = new RequestOptions({ headers: headers });		
        return options;
    }
    configOptionsWithToken(token) {
        let headers = new Headers();
        headers.append('Authorization', 'Bearer ' + token);
        let options = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': 'my-auth-token'
            })
        };
        // = new RequestOptions({ headers: headers });
        return options;
    }
}
HttpHelperService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function HttpHelperService_Factory() { return new HttpHelperService(); }, token: HttpHelperService, providedIn: "root" });
